import script from "./QLicensePlate.vue?vue&type=script&setup=true&lang=js"
export * from "./QLicensePlate.vue?vue&type=script&setup=true&lang=js"

import "./QLicensePlate.vue?vue&type=style&index=0&id=8ac4e9b6&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ac4e9b6"]])

export default __exports__